import React from "react";
import Select from "react-select";

export var RatingSelect = ({ currentSelectStyles, placeholder, options, fieldName, values, arrayHelpers, index }) => (<Select
  isSearchable
  styles={currentSelectStyles}
  placeholder={placeholder}
  options={options.map(x => ({ label: x.label, value: x.value }))}
  value={options.find(x => x.value === values[index][fieldName])}
  onChange={(a, b) => {
    const { name, value } = a;
    const newValue = values[index];
    newValue[fieldName] = value;
    arrayHelpers.replace(index, newValue);
  }}
/>);
